jQuery('.offcanvas .current-menu-item').attr('data-bs-dismiss', 'offcanvas');
    
